module.exports = __webpack_public_path__ + "img/pic-2.9e69685f.png";